var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",attrs:{"width":_vm.svgSize.width,"height":_vm.svgSize.height,"fill":"currentColor"}},[_c('use',{attrs:{"xlink:href":`#${_vm.svg.id}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }